import PEPLayout from 'components/layouts/VirtualRoom/PEPLayout'

export default function MedicalRecordLayout() {
  return <PEPLayout />
}
